export default function ifdo (fn) {
  if (this.length > 0)
    fn.call(this);
};
